module.exports = __webpack_public_path__ + "static/media/041.a9b43fb8.jpg";